import type { DialogAPI } from '@fukku/dialog'
import { BottomSheet } from '@fukku/dialog/BottomSheet'
import { Header } from '@fukku/dialog/Header'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useEffect, useRef } from 'react'

type ChatModalSearchAddressProps = {
	isSearchAddressOpen: boolean
	onCancelSearchAddress: () => void
}

export const ChatModalSearchAddress = ({
	isSearchAddressOpen,
	onCancelSearchAddress,
}: Readonly<ChatModalSearchAddressProps>) => {
	const sheetRef = useRef<DialogAPI>(null)
	const { t } = useLabels()

	useEffect(() => {
		if (isSearchAddressOpen) {
			sheetRef.current?.show()
		}
	}, [isSearchAddressOpen])

	return (
		<BottomSheet
			ref={sheetRef}
			title={t('assistant.changeAddress.title')}
			data-testid='colorsSelectorSheet'
			onClose={onCancelSearchAddress}
		>
			<Header title={t('assistant.changeAddress.title')} />
		</BottomSheet>
	)
}
